import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aca4ace"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "digital_info_setting" }
const _hoisted_2 = { class: "top_view" }
const _hoisted_3 = { class: "yl-add-wrapper" }
const _hoisted_4 = { class: "yl-add-content" }
const _hoisted_5 = { class: "input-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require" }, "名称：", -1))
const _hoisted_7 = { class: "input-content" }
const _hoisted_8 = { class: "career_and_tone_bg" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title_tips" }, "职业：", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title_tips" }, "语气：", -1))
const _hoisted_11 = { class: "tone_librarys" }
const _hoisted_12 = { class: "initial_capability_bg" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "initial_capability_title" }, "初始能力：", -1))
const _hoisted_14 = { class: "initial_capabilitys" }
const _hoisted_15 = { class: "input-wrapper role_desc_bg" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "role_desc" }, "角色描述：", -1))
const _hoisted_17 = { class: "input-content role_description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButtonItem = _resolveComponent("BackButtonItem")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BackButtonItem, {
        onBackBtnClick: _ctx.backButtonClick,
        class: "back_button"
      }, null, 8, ["onBackBtnClick"]),
      _createElementVNode("button", {
        class: "submit_button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, "确认")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.tempPersonality.npcName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tempPersonality.npcName) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_el_select, {
            class: "career_el_select",
            modelValue: _ctx.careerItem,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.careerItem) = $event)),
            placeholder: "请选择"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.careerList, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.name,
                  value: item.name,
                  disabled: !item.allow
                }, null, 8, ["label", "value", "disabled"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toneList, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_button, {
                class: _normalizeClass(['tone_library_item', _ctx.selectedTone === item ? 'tone_library_item_selected' : '']),
                onClick: ($event: any) => (_ctx.toneLibraryItemClick(item)),
                disabled: !item.allow && _ctx.selectedTone != item
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["class", "onClick", "disabled"]))
            }), 256))
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initialCapabilityList, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_button, {
                class: _normalizeClass(['initial_capability_item', _ctx.selectedCapabilityItem === item ? 'initial_capability_item_selected' : '']),
                onClick: ($event: any) => (_ctx.initialCapabilityItemClick(item)),
                disabled: !item.allow && _ctx.selectedCapabilityItem != item
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["class", "onClick", "disabled"]))
            }), 256))
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: _ctx.tempPersonality.introduction,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tempPersonality.introduction) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]))
}